<template>
  <template v-for="(option, index) in options" :key="index">
    <div class="form-check">
      <input
        type="radio"
        :value="option.value"
        v-model="proxyChecked"
        :name="id + '_radio'"
        :id="id + '_radio-' + index"
        class="form-check-input"
      />

      <label class="form-check-label" :for="id + '_radio-' + index">
        {{ option.label }}
      </label>
    </div>
  </template>

  <!-- <pre>{{ proxyChecked }}</pre> -->
</template>

<script>
export default {
  emits: ["update:checked"],

  props: {
    checked: {
      type: String,
      default: null,
    },

    options: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },

  computed: {
    proxyChecked: {
      get() {
        return this.checked;
      },

      set(val) {
        this.$emit("update:checked", val);
      },
    },
  },
};
</script>

<style>
</style>